import { render, staticRenderFns } from "./UsersStatisticsPage.vue?vue&type=template&id=33d71fc1&scoped=true"
import script from "./UsersStatisticsPage.vue?vue&type=script&lang=js"
export * from "./UsersStatisticsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d71fc1",
  null
  
)

export default component.exports